<template>
    <div :class="{ 'has-logo': showLogo }">
        <logo v-if="showLogo" :collapse="isCollapse" />
        <!-- <el-scrollbar wrap-class="scrollbar-wrapper"> -->
        <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="'unset'" :unique-opened="false"
            :collapse-transition="false" mode="horizontal">
            <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
        </el-menu>
        <!-- </el-scrollbar> -->
        <!-- <el-scrollbar wrap-class="scrollbar-wrapper">
            <el-menu
                :default-active="activeMenu"
                :collapse="isCollapse"
                :background-color="variables.menuBg"
                :text-color="variables.menuText"
                :unique-opened="false"
                :active-text-color="variables.menuActiveText"
                :collapse-transition="false"
                mode="horizontal"
            >
                <sidebar-item
                    v-for="route in routes"
                    :key="route.path"
                    :item="route"
                    :base-path="route.path"
                />
            </el-menu>
        </el-scrollbar> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
    components: { SidebarItem, Logo },
    computed: {
        ...mapGetters([
            'sidebar'
        ]),
        routes() {
            return this.$router.options.routes
        },
        activeMenu() {
            const route = this.$route
            const { meta, path } = route
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        },
        showLogo() {
            return this.$store.state.settings.sidebarLogo
        },
        variables() {
            return variables
        },
        isCollapse() {
            return !this.sidebar.opened
        }
    },
    mounted() {
        // console.log(variables)
    },
}
</script>
<style lang="scss">
.el-menu {
    display: flex;
    width: auto !important;
    background-color: unset !important;
    color: #fff;

    .el-menu-item {
        color: #fff !important;
        // padding: 0 10px !important;
        font-size: 12px;
        font-family: SourceHanSerifCN-Regular; // SourceHanSerifCN-Bold;
        height: 60px !important;
        line-height: 60px !important;
        padding: 0 5px !important;

        &:hover {
            background-color: unset !important;
        }

        span {
            padding: 4px 11px;

            &:hover {
                background-color: #50A088 !important;
                color: #FFFFFF;
                border-radius: 4px;
            }
        }

        &.is-active span {
            background-color: #50A088 !important;
            color: #FFFFFF;
            border-radius: 4px;
            font-family: SourceHanSerifCN-Bold;
        }
    }

    .el-submenu__title {
        color: #ffffff;
        height: 60px !important;
        line-height: 61px !important;
        font-size: 12px;
        font-family: SourceHanSerifCN-Regular;
        padding: 0 10px !important;

        span {
            padding: 4px 11px;

            &:hover {
                background-color: #50A088 !important;
                color: #FFFFFF;
                ;
                border-radius: 6px;
            }
        }

        &:hover {
            background-color: unset !important;
        }

        &.is-active span {
            // background-color: #1f6c4f !important;
            background-color: #50A088 !important;
            color: #FFFFFF;
            ;
            border-radius: 6px;
            font-family: SourceHanSerifCN-Bold;
        }
    }

    .el-submenu {
        &.is-active span {
            // background-color: #1f6c4f !important;
            background-color: #50A088 !important;
            color: #FFFFFF;
            font-family: SourceHanSerifCN-Bold;
            border-radius: 6px;
        }

        .el-submenu__icon-arrow {
            color: #fff;
            position: absolute;
            right: 5px;
            display: none
        }
    }

    &.el-menu--horizontal {
        border-bottom: none !important;
    }
}

.el-menu--horizontal {
    // background: #134a34;
    background: #50A088;

    // top: 80px !important;
    .el-menu {
        display: block;
    }

    .el-menu--popup {
        min-width: 90px;
        padding-top: 10px;

        &::before {
            width: 0;
            height: 0;
            display: block;
            content: "";
            border: 9px solid transparent;
            border-top: 6px solid transparent;
            border-top-color: #208060;
            left: 50%;
            position: absolute;
            top: -5px;
            margin-left: -9px;
        }

        .el-menu-item {
            height: 24px !important;
            line-height: 20px !important;
            text-align: center;
            margin-bottom: 5px;

            span {

                // padding: 4px 11px;
                &:hover {
                    background-color: #FFFFFF !important;
                    color: #50A088;
                    ;
                    border-radius: 6px;
                }
            }

            &.is-active span {
                background-color: #FFFFFF !important;
                color: #50A088;
                border-radius: 6px;
            }
        }
    }
}

.park-poper-menu {
    // top: 80px !important;
    margin-left: -12px;
    border-radius: 0px 0px 6px 6px;
}

.park-poper-menu1 {
    // top: 80px !important;
    margin-left: -6px;
    border-radius: 0px 0px 6px 6px;
}

@media screen and (min-width: 1920px) {
    .el-menu {
        height: 80px;

        .el-menu-item {
            height: 80px !important;
            line-height: 80px !important;
            font-size: 14px !important;
            font-weight: normal;
        }

        .el-submenu__title {
            height: 80px !important;
            line-height: 81px !important;
            font-size: 14px !important;
            font-weight: normal;
        }
    }
    .park-poper-menu1 {
        margin-left: 1px;
    }
}
</style>
